import { Newspaper } from "lucide-react";
import { useState } from "react";
import { SidebarButtonItem } from "../navigation/SidebarItem";
import { NeuigkeitenBereich } from "./NeuigkeitenBereich";
import { useFeatureHintsContext } from "./FeatureHintsContext";

/**
 * Der Eintrag "Neuigkeiten" an der Stelle von "Hilfe" (KAN-251, A1). Oeffnet und schliesst
 * den Bereich per Klick (A2) - die Hilfe-Seite bleibt ueber ihre Adresse erreichbar (A10),
 * nur nicht mehr verlinkt.
 */
export const NeuigkeitenEinstieg = () => {
  const [open, setOpen] = useState(false);
  const { hints, unreadCount, readOnly, markRead, markAllRead } = useFeatureHintsContext();

  return (
    <>
      <SidebarButtonItem
        title="Neuigkeiten"
        icon={<Newspaper size={30} strokeWidth={1.75} />}
        isActive={open}
        badgeCount={unreadCount}
        markierung="neuigkeiten"
        onClick={() => setOpen(value => !value)}
      />
      <NeuigkeitenBereich
        open={open}
        hints={hints}
        readOnly={readOnly}
        onClose={() => setOpen(false)}
        onMarkRead={markRead}
        onMarkAllRead={markAllRead}
      />
    </>
  );
};

export default NeuigkeitenEinstieg;
